import './utils/referralAttribution'
import { shortName } from '@utils/shortName'
import './utils/referralLinkToken'
import './tc-focus.js'
// Records the first landing before the router rewrites the URL (Test Candidates only)
import '@groupResources/signup-source/tc-signup-source.js'
import './tc-focus.css'
import App from './App.vue'
import router from '@router'
import store from '@store'
import Vue from 'vue'
import VueGtm from 'vue-gtm'
import FeaturesService from '@plugins/FeaturesService'
import VueTour from 'vue-tour'
import InstantSearch from 'vue-instantsearch'
import VueObserveVisibility from 'vue-observe-visibility'

import '@components/_globals'
import TcSelect from '@components/EmployerV2/Select'

import PortalVue from 'portal-vue'
import GSignInButton from 'vue-google-signin-button'

import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'
import { analyticsView } from '@utils/analyticsView'
import { isKeyedAddress, sentryBeforeSend, sentryBeforeBreadcrumb } from '@utils/keyedAddress'
Vue.component('TcSelect', TcSelect)

Vue.use(PortalVue)
Vue.use(FeaturesService)
Vue.use(VueTour)
Vue.use(InstantSearch)
Vue.use(GSignInButton)
Vue.use(VueObserveVisibility)

const referralPage = /^\/referrals(?:\/|$)/.test(window.location.pathname)
// Share links, client packs and their print pages carry a secret token in the address, and are read by
// people outside the account. Google Tag Manager (and GA4 through it) records the address and referrer, so
// it never loads there. Nothing on those pages needs it: the app renders no cookie banner and sends no
// funnel event from them.
const keyedPage = isKeyedAddress(window.location.pathname)
if (process.env.VUE_APP_GOOGLE_CONTAINER_ID && !referralPage && !keyedPage) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_CONTAINER_ID
  })
  router.afterEach(to => {
    const view = analyticsView(to)
    if (view) Vue.gtm.trackView(view.name, view.path)
  })
}

if (process.env.VUE_APP_SENTRY_DSN && !referralPage) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
    release: process.env.VUE_APP_SENTRY_RELEASE || undefined,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    // Errors on a share link are still worth knowing about, but not with the token in the address.
    beforeSend: sentryBeforeSend,
    beforeBreadcrumb: sentryBeforeBreadcrumb
  })
}

// Short assessment names, see utils/shortName
Vue.filter('shortName', (value, max) => shortName(value, max))

// Capitalize
// @TODO - move to separate file
Vue.filter('capitalize', value => {
  if (!value && value !== 0) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
